import '../styles/TestResult.css';

import { Box, MenuItem, Select } from '@mui/material';
import React, { useEffect, useState } from 'react';
import {
	getExamSummary,
	getReattempSummary,
	getSFTData,
	getUserAttempts,
} from '../services/ExamScoreApi';
import { useDispatch, useSelector } from 'react-redux';

import Button from '../components/atoms/Button';
import TestModule from './TestModule/TestModule';
import TestSummary from './TestSummary';
import { dateFormater } from '../hooks/dateFormater';
import { logger } from '../utils/logger';
import { setAttempt } from '../store/testSelectionSlice';

const TestResult = ({ setWrongQuestions, setExamNameTop }) => {
	const {
		examId,
		selectedTest,
		attempt: attemptState,
		reattemptId,
	} = useSelector((state) => state.testSelection);
	const { userId } = useSelector((state) => state.userDetails);

	const dispatch = useDispatch();

	const [totalTime, setTotalTime] = useState('');
	const [correctTime, setCorrectTime] = useState('');
	const [wrongTime, setWrongTime] = useState('');
	const [unattemptedTime, setUnattemptedTime] = useState('');
	const [testDate, setTestDate] = useState('');
	const [attempt, setAttemptState] = useState(attemptState || '1');
	const [examName, setExamName] = useState();
	const [sections, setSections] = useState([]);
	const [correctAnswers, setCorrectAnswers] = useState({});
	const [TotalQuestions, setTotalQuestions] = useState({});
	const [dataForTable, setDataForTable] = useState();
	const [loading, setLoading] = useState(false);
	const [attempts, setAttempts] = useState(0);

	// Updated score states to handle separate math and EBRW scores
	const [scores, setScores] = useState({
		raw: { ebrw: 0, math: 0 },
		scaled: { ebrw: 0, math: 0 },
		total: 0,
	});

	const [sftScore, setSftScore] = useState(0);

	const totalScore = selectedTest === 'SFT' ? 400 : 1600;

	const frequentMistakes = ['Mistake 1', 'Mistake 2', 'Mistake 3'];

	useEffect(() => {
		loadData();
	}, [attempt, selectedTest, reattemptId]);

	const getUsrAtempts = async () => {
		const res = await getUserAttempts(examId, userId);
		setAttempts(res?.data?.totalAttempts);
	};
	useEffect(() => {
		getUsrAtempts();
	}, []);

	const loadData = async () => {
		setLoading(true);
		let res;
		let examData;
		if (selectedTest === 'SFT') {
			logger.log('SFT call');
			res = await getSFTData(examId, userId);
			examData = res?.data;
			setExamName(examData?.test_name);
			// testDate = examData?.COMPLETED_AT;
			setTestDate(dateFormater(examData?.COMPLETED_AT));
		} else if (selectedTest === 'SAT') {
			res = await getExamSummary(examId, attempt, userId);
			examData = res?.data?.examData;
			setExamName(examData?.exam_name);
			setExamNameTop(examData?.exam_name);
			setTestDate(dateFormater(res?.data?.examData?.attempt?.completedAt));
			setWrongQuestions(examData?.wrongQuestions);
			// testDate = res?.data?.examData?.attempt?.completedAt;
		} else if (selectedTest === 'SATReattempt') {
			res = await getReattempSummary(userId, reattemptId);
			examData = res?.data;
			setExamName(examData?.exam_name);
			setTestDate(dateFormater(examData?.COMPLETED_AT));
		}
		// let sections = examData.sections;
		examData?.sections?.forEach((section) => {
			setSections((prev) => {
				if (!prev.includes(section.name)) {
					return [...prev, section.name];
				}
				return prev;
			});
		});

		// let section1Modules = sections[0].modules;
		// let section1Module1 = section1Modules[0];
		// check this out
		const correctAnswersObj = examData?.sections?.reduce((acc, section) => {
			const modulesObj = section?.modules?.reduce((modAcc, module) => {
				modAcc[module.name] = module?.correct_answers;
				return modAcc;
			}, {});

			acc[section?.name] = modulesObj;

			return acc;
		}, {});
		setCorrectAnswers(correctAnswersObj);
		// setSection1Module1CorrectAnswers(section1Module1.correct_answers);
		const totalAnswersObj = examData?.sections?.reduce((acc, section) => {
			const modulesObj = section?.modules?.reduce((modAcc, module) => {
				modAcc[module?.name] = module?.total_questions;
				return modAcc;
			}, {});
			acc[section?.name] = modulesObj;
			return acc;
		}, {});
		setTotalQuestions(totalAnswersObj);
		// setSection1Module1TotalQuestions(section1Module1.total_questions);
		// let section1Module2 = section1Modules[1];
		// setSection1Module2CorrectAnswers(section1Module2.correct_answers);
		// setSection1Module2TotalQuestions(section1Module2.total_questions);

		// setSection2Name(sections[1].name);
		// let section2Modules = sections[1].modules;
		// let section2Module1 = section2Modules[0];
		// setSection2Module1CorrectAnswers(section2Module1.correct_answers);
		// setSection2Module1TotalQuestions(section2Module1.total_questions);
		// let section2Module2 = section2Modules[1];
		// setSection2Module2CorrectAnswers(section2Module2.correct_answers);
		// setSection2Module2TotalQuestions(section2Module2.total_questions);
		if (selectedTest === 'SFT') {
			setSftScore(examData?.score?.scaledScore);
		} else if (selectedTest === 'SATReattempt') {
			setScores(examData?.score);
		} else {
			setScores(
				examData?.attempt?.scores || {
					raw: { ebrw: 0, math: 0 },
					scaled: { ebrw: 0, math: 0 },
					total: 0,
				}
			);
		}
		// setTotalScore(examData?.attempt?.total_score);

		let transformedData = transformExamData(examData);
		setDataForTable(transformedData);
		calculateTimes(transformedData);

		setLoading(false);
	};

	const transformExamData = (examData) => {
		const transformedData = [];

		examData.sections.forEach((section) => {
			section.modules.forEach((module) => {
				module.questions.forEach((question) => {
					transformedData.push({
						section: `${section?.name}: ${module?.name}`,
						no: question?.question_no,
						questionType: question?.answer?.ANSWER_TYPE,
						correctAnswer:
							question?.answer?.CORRECT_OPTION || question?.answer?.CORRECT_ANSWER,
						yourChoice: question?.your_choice,
						explanation: question?.answer?.EXPLANATION,
						question: question?.question,
						options: question?.options,
						timeTaken: question?.timeTaken,
					});
				});
			});
		});

		return transformedData;
	};

	const calculateTimes = (questions) => {
		let total = 0;
		let correct = 0;
		let wrong = 0;
		let unattempted = 0;
		questions.forEach((question) => {
			const time = Number(question.timeTaken);
			if (isNaN(time)) {
				return;
			}
			total += time;
			if (question.yourChoice === question.correctAnswer) {
				correct += time;
			} else if (question.yourChoice !== 'Omitted') {
				wrong += time;
			} else {
				unattempted += time;
			}
		});

		setTotalTime(formatTime(total));
		setCorrectTime(formatTime(correct));
		setWrongTime(formatTime(wrong));
		setUnattemptedTime(formatTime(unattempted));
	};

	const formatTime = (totalSeconds) => {
		const minutes = Math.floor(totalSeconds / 60);
		const seconds = (totalSeconds % 60).toFixed(0);
		return `${minutes} min : ${seconds} sec`;
	};

	const shareInvite = () => {
		logger.log('Invite shared');
	};

	const attemptsMenuItem = () => {
		let listItems = [];
		for (let i = 2; i <= attempts; i++) {
			listItems.push(<MenuItem value={i}>{`Attempt ${i}`}</MenuItem>);
		}
		return <React.Fragment>{listItems}</React.Fragment>;
	};
	return (
		<div className="test-result-container">
			{loading ? (
				<div className="loader"></div>
			) : (
				<div className="test-result-content">
					<div className="test-result-header">
						<Box sx={{ display: 'flex', flexDirection: 'row', gap: '1rem' }}>
							<div className="testName">{examName}</div>
							{selectedTest === 'SAT' && (
								<Box>
									<Select
										id="demo-simple-select"
										value={attempt}
										size="small"
										label=""
										onChange={(e) => {
											setAttemptState(e.target.value);
											dispatch(setAttempt(e.target.value));
										}}
									>
										{[...Array(attempts)].map((_, index) => {
											const attemptNumber = index + 1;
											return (
												<MenuItem key={attemptNumber} value={attemptNumber}>
													Attempt {attemptNumber}
												</MenuItem>
											);
										})}
									</Select>
								</Box>
							)}
						</Box>
						<div className="test-result-date">{testDate}</div>
					</div>
					<div className="test-result-score">
						<div className="test-result-score-col1">
							<p>Final Score</p>
						</div>
						<div className="test-result-score-col2">
							<p>
								<span className="blue">
									{selectedTest === 'SFT' ? sftScore : scores?.total}
								</span>{' '}
								/{' '}
								{selectedTest !== 'SATReattempt'
									? totalScore
									: scores?.totalQuestions}
							</p>
						</div>
					</div>
					<div className="test-result-modules">
						{sections.map((section) => {
							return (
								<TestModule
									SectionName={section}
									score={
										selectedTest === 'SFT'
											? sftScore
											: section === 'Reading & Writing'
											? scores?.scaled?.ebrw
											: scores?.scaled?.math
									}
									totalScore={
										selectedTest !== 'SATReattempt'
											? selectedTest !== 'SFT'
												? totalScore / 2
												: totalScore
											: scores?.totalQuestions
									}
									CorrectQuestions={correctAnswers}
									TotalQuestions={TotalQuestions}
									frequentMistakes={frequentMistakes}
								/>
							);
						})}
					</div>
					<div className="time-distribution">
						<div className="time-distribution-header">
							<span>Time Distribution</span>
						</div>
						<span>Total Time taken: {totalTime}</span> <br />
						<span>Time taken for Correct Ans: {correctTime}</span> <br />
						<span>Time taken for Wrong Ans: {wrongTime}</span> <br />
						<span>Time taken for Unattempted: {unattemptedTime}</span> <br />
					</div>
					<div className="test-summary">
						<TestSummary data={dataForTable}></TestSummary>
					</div>
					<div className="test-invite">
						<div className="test-invite-col1">
							Invite your friends to take a DSAT Exam with you
						</div>
						<div className="test-invite-col2">
							<Button
								label="Share an Invite"
								onClick={shareInvite}
								className="invite-button"
							/>
						</div>
					</div>
					<div className="test-feedback">
						<div className="test-feedback-row1">
							Suggested Concepts needed to enhance
						</div>
						<div className="test-feedback-row2">
							<div className="sub-topic">SubTopic 1</div>
							<div className="sub-topic">SubTopic 2</div>
							<div className="sub-topic">SubTopic 3</div>
							<div className="sub-topic">SubTopic 4</div>
							<div className="sub-topic">SubTopic 5</div>
						</div>
					</div>
				</div>
			)}
		</div>
	);
};

export default TestResult;
